"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const unevenskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-unevenskin` : '') + (description ? ` desc-unevenskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-unevenskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-unevenskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.66 12.15a.75.75 0 0 1 .83 1.25l-.07.04-.01.01a3.97 3.97 0 0 1-.58.29c-.31.13-.8.3-1.29.3a3.6 3.6 0 0 1-1.29-.3 5.9 5.9 0 0 1-.57-.29h-.02a.75.75 0 0 1 .76-1.3l.03.01c.01.02.04.03.08.05l.31.15c.27.11.53.19.7.19a2 2 0 0 0 .7-.2c.13-.04.24-.1.31-.14l.09-.05h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.37 16.06a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.34 14.8a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.74 13.6a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.66 12.15a.75.75 0 0 1 .83 1.25l-.07.04-.01.01a3.97 3.97 0 0 1-.58.29c-.31.13-.8.3-1.29.3a3.6 3.6 0 0 1-1.29-.3 5.9 5.9 0 0 1-.57-.29h-.02a.75.75 0 0 1 .76-1.3l.03.01c.01.02.04.03.08.05l.31.15c.27.11.53.19.7.19a2 2 0 0 0 .7-.2c.13-.04.24-.1.31-.14l.09-.05h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9.56a7.82 7.82 0 0 1 4.73-.32c.65.2 1.23.51 1.67.96a8.2 8.2 0 0 1 6.5 2.78c1.56 1.85 2.23 4.46 1.8 7.4-.35 2.51-1.03 4.99-2.74 6.85l-.11.33a7.83 7.83 0 0 1-4.24 4.4 7.8 7.8 0 0 1-5.75.15l-.36-.15a7.81 7.81 0 0 1-3.97-3.78 10.84 10.84 0 0 1-4.08-8.37v-.53c.09-5.4 3.28-8.54 6.54-9.72Zm4.08 5.79a6.32 6.32 0 0 0-5.83 6.32v2.86a6.34 6.34 0 0 0 5.83 6.54v-2.1a6.05 6.05 0 0 1-1.9-.33.75.75 0 0 1 .5-1.42 4.55 4.55 0 0 0 1.4.25V17.3a3.56 3.56 0 0 1-.51-.19l-.08-.04h-.03v-.01a.75.75 0 0 1 .62-1.36V6.35Zm1.2 1.25a5.04 5.04 0 0 1 1.44.72c.25.2.47.44.56.73.13.38 0 .73-.22 1.04-.22.3-.55.58-.88.8-.32.22-.65.4-.9.52v4.28a.75.75 0 0 1 .67 1.34l-.07.04h-.01l-.03.01-.08.04a4.08 4.08 0 0 1-.48.18v1.14c.1 0 .19-.02.28-.03l.23-.04c.23-.04.43-.1.6-.15a.75.75 0 0 1 .48 1.42 6.03 6.03 0 0 1-1.6.3v.8l.57.15c.28.07.57.17.82.3.19.08.36.2.48.34l.17-.08a6.31 6.31 0 0 0 3.55-5.92v-.04l.05-2.82a6.35 6.35 0 0 0-5.63-6.3V7.6Zm-.97-5.92a6.34 6.34 0 0 0-3.8.29c-2.74 1-5.49 3.62-5.56 8.35v.47a9.35 9.35 0 0 0 1.8 5.44 7.86 7.86 0 0 1 0-.72v-2.84a7.85 7.85 0 0 1 7.55-7.83 1.6 1.6 0 0 0 1.42-1.6 1.38 1.38 0 0 0-.29-.87c-.23-.3-.6-.53-1.12-.69Zm2.87 1.05a3.15 3.15 0 0 1-.58 2.37 7.83 7.83 0 0 1 5.8 7.57v.01l-.03 2.02c.41-1.07.67-2.26.85-3.54.38-2.59-.23-4.75-1.47-6.22a6.5 6.5 0 0 0-4.57-2.21Z",
    fill: "#232323"
  }));
};
var _default = exports.default = unevenskin;